import axios from '../index'
export default {
    
    getInstitucion (params) {
        return axios.get('/instituciones/usuario/', {
            params
        })
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    getPrograma (institucionId) {
        return axios.get('/programas/institucion/'+ institucionId)
    },
    getPlanEstudios (programaId, params = {}) {
        return axios.get('/planesEstudio/porProgramaId/' + programaId, {
            params
        })
    },
    getNivelAcademicoProgramas(){
        return axios.get('/niveles-academicos/getAll')
    },
    getNivelAcademico (params) {
        return axios.get('/niveles-academicos/filtrar', {params})
    },
    getEscala (params) {
        return axios.get('/escala-de-calificaciones/filtrar', {params})
    },
    getActualizar(id, formData){
        return axios.post('/escala-de-calificaciones/actualizar/' + id, formData)
    },
    getCrear(formData){
        return axios.post('/escala-de-calificaciones/guardar', 
        formData)
    },
    getEliminar(formData){
        return axios.post('/escala-de-calificaciones/eliminar/' + formData)
    },
    profesoresGA(params){
        return axios.get('/asignar-bloques/getDocentesCodigoSesion', {params})
    },
    // CONFIGURACION 
    getCrearConfiguracion(formData){
        return axios.post('/api/v1/academico/configuracion/evaluaciones/crear', formData)
    },
    getFiltros(params){
        return axios.get('/api/v1/academico/configuracion/evaluaciones/filtrar', {params})
    },
    getEditarConfiguracion(id, formData){
        return axios.post('/api/v1/academico/configuracion/evaluaciones/' + id + '/editar', formData)
    },
    getEliminarConfiguracion(detalleComponenteId){
        return axios.post('/api/v1/academico/configuracion/evaluaciones/' + detalleComponenteId + '/eliminar')
    },
    getComponenteAcademico(params){
        return axios.get('/getComponentesAcademicos', {params})
    },
    getDetalleComponenteAcademico(params){
        return axios.get('/getDetalleComponenteAcademicoAllTipos', {params})
    },
    // MATERIAS PROMEDIABLES
    getGuardarActualizar(formData){
        return axios.post('/materias-promediables/store', formData)
    },
    getMaterias(params){
        return axios.get('/materias-promediables/getMaterias', {params})
    },
    getEliminarMateria(params){
        return axios.get('/materias-promediables/delete', {params})
    },
    
    //COMPONENTES ACADEMICOS
    getInfoComponentes(params){
        return axios.get('/componentes-academicos/paginate', {params})
    },
    getEditarComponentes(formData, id){
        return axios.post('/detalle-componentes-academicos/update/' + id, formData)
    },
    getCrearGuardar(formData){
        return axios.post('/componentes-academicos/store', formData) 
    },
    getCrearGeneral(formData, id){
        return axios.post('/detalle-componentes-academicos/store/' + id, formData)
    },
    getEscalaCalificaciones(){
        return axios.get('/escala-de-calificaciones/all')
    },
    getEditarComponentesGeneral(formData, id){
        return axios.post('/componentes-academicos/update/' + id, formData)
    },

    // FECHAS DE VIGENCIA DE COBRO 
    getInfoFechasVigencia(params){
        return axios.get('/fechas-de-vigencia/filtrar', {params})
    },
    getNivelAcademico (params) {
        return axios.get('/niveles-academicos/filtrar', {params})
    },
    getCrearFecha(formData){
        return axios.post('/fechas-de-vigencia/guardar', formData)
    },
    getEditarFecha(formData, id){
        return axios.post('/fechas-de-vigencia/actualizar/' + id, formData)
    },
    getEliminarFecha(formData, id){
        return axios.post('/fechas-de-vigencia/eliminar/' + id, formData)
    },

    // CÓDIGO DE DETALLE 
    getInfoCodigoDetalle(params){
        return axios.get('/codigos-de-detalle/filtrar', {params})
    },
    postCrearCodigoDetalle(formData){
        return axios.post('/codigos-de-detalle/guardar', formData)
    },
    getInfoModal(id){
        return axios.get('/codigos-de-detalle/editar/' + id)
    },
    getListadoTipoAbono(params){
        return axios.get('/codigos-de-detalle/listado', {params})
    },
    postEditarCodigoDetalle(formData, id){
        return axios.post('/codigos-de-detalle/actualizar/' + id, formData)
    },
    postEliminarCodigoDetalle(id){
        return axios.post('/codigos-de-detalle/eliminar/' + id)
    },

    // GESTION DE BECAS 
    getInfoBecas(params){
        return axios.get('/becas/paginate', {params})
    },
    portCrearBecas(formData){
        return axios.post('/becas/store', formData)
    },
    portEditarBecas(formData, id){
        return axios.post('/becas/update/' + id, formData)
    },
    getConvenios(params){
        return axios.get('/becas/getConveniosPorInstitucion',{ params })
    },

    // PROMOCIONES
    getInfoPromociones(params){
        return axios.get('promociones/filtrar', {params})
    },
    getAbonoPromociones(){
        return axios.get('/codigos-de-detalle/descuentos')
    },
    getCargosPromociones(){
        return axios.get('/codigos-de-detalle/cargos')
    },
    getEditarPromociones(payload){
        return axios.post('/promociones/actualizar', payload)
    },
    getCrearPromociones(payload){
        return axios.post('/promociones/guardar', payload)
    },

    // CONFIGURACION BOLETA 
    getInfoConfiguracionBoleta(params){
        return axios.get('/configuracion-boletas/getConfiguracionesBoletas', {params})
    },
    postCrearConfiguracionBoleta(payload){
        return axios.post('/configuracion-boletas/storeConfigBoleta', payload)
    },
    getPeriodosConfiguracionBoleta(params){
        return axios.get('/getDetalleComponenteAcademicoAllTipos', {params})
    },

    // DOCENTES 
    getDocentes(params){
        return axios.get('/docentes/show', {params})
    },
    getGenerarAccesos(idProf){
        return axios.get('/docentes/generar-accesos/' + idProf)
    },
    getRecuperarContrasena(idProf){
        return axios.get('/panel/usuario/reset-password/' + idProf)
    },
    getDocentesVincular(institucion){
        return axios.get('/docentes/porInstitucionId/' + institucion)
    },
    getCrearDocente(formData){
        return axios.post('/docentes/store', formData)
    },
    postVincularDocente(payload){
        return axios.post('/docentes/vincular', payload)
    },
    postSubirExcel(institucion, formData){
        return axios.post('/docentes/upload_docentes/' + institucion, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }, 
    postCrearMasivo(institucion, params){
        return axios.post('/docentes/save_docentes/' + institucion, params)
    },
    getDeshabilitarDocente(params){
        return axios.get('/docentes/desvincular', {params})
    },
    getBloquearDocente(params){
        return axios.get('/docentes/bloquear', {params})
    },

    // PROGRAMAS
    getAcademicoProgramas(params){
        return axios.get('/programas/filtrar', {params})
    },
    postProgramasCrear(formData){
        return axios.post('programas/guardar', formData)
    },
    getEditarProgramas(id){
        return axios.get('/programas/editar/' + id)
    },
    postProgramasEditar(id, formData){
        return axios.post('programas/actualizar/' + id, formData)
    },

    // SUBCATEGORIA 
    getSubcategoriasServicios(params){
        return axios.get('api/v1/subcategorias-servicios/getSubcategorias', {params})
    },
    getCrearSubcategorias(payload){
        return axios.post('api/v1/subcategorias-servicios/store', payload)
    },
    getEditarSubcategorias(payload){
        return axios.post('api/v1/subcategorias-servicios/store', payload)
    },
    postEliminarSubcategoria(payload){
        return axios.post('api/v1/subcategorias-servicios/delete', payload)
    },
    getCodigoDetallesServicios(){
        return axios.get('api/v1/subcategorias-servicios/getCodigosDetallesServicios')
    },

    // PLANES DE ESTUIDO 
    getPlanesEstudios(planId){
        return axios.get('asignaturas/leerPlan/' + planId)
    },
    getAsignaturas (planId, params = {}) {
        return axios.get('/asignaturas/porPlanDeEstudiosId/' + planId, {
            params
        })
    },
    postCrearPlan(params){
        return axios.post('/asignaturas/crearPlan', params )
    },
    postEditarPlan(idPlan, formData){
        return axios.put('/planesEstudio/editPlanEstudio/' + idPlan, formData )
    },
    postCrearAsignatura(payload){
        return axios.post('/asignaturas/crearAsignatura', payload)
    },
    postEditarAsignatura(asignaturaId, payload){
        return axios.post('/asignaturas/actualizarAsignatura/' + asignaturaId, payload)
    },
    getGrado(id){
        return axios.get('/programas/grados/' + id)
    },
    postEditarArea(idArea, payload){
        return axios.post('/asignaturas/actualizarArea/' + idArea, payload)
    },
    postCrearArea(payload){
        return axios.post('/asignaturas/crearArea', payload)
    },
    rearrangeAsignatura(payload){
        return axios.post('/asignaturas/actualizarOrden', payload)
    },

    // AULA VS ALUMNO
    getAulaVsAlumno(params){
        return axios.get('/planta-fisica/getAulasOcupacion', {params})
    },
    getAulaVsAlumnoCicloEscolar(institucion){
        return axios.get('/planta-fisica/getCiclosEscolaresDePlantel/' + institucion)
    }
}